import {Injectable} from '@angular/core';
import {Subscription, timer} from 'rxjs';
import {finalize} from 'rxjs/operators';

import {BEAR_ANIM, BEAR_BLINK_DELAY, BEAR_BLINK_DURATION} from '../../defines/client.const';
import {getEnumNameByValue} from "../../defines/common.func";
import {VoiceService} from '../voice/voice.service';

enum STATE {
  NONE,
  SPEAK,
  TYPING,
  BLINKING,
}

@Injectable({
  providedIn: 'root'
})
export class BearService {
  private state: STATE = STATE.NONE;

  private timer$: Subscription | null = null;


  constructor(
    private voiceSvc: VoiceService,
  ) {
    this.resetBlinkTimer();
  }

  public get numAni(): BEAR_ANIM {
    if (this.voiceSvc.on) {
      if (this.state !== STATE.SPEAK) {
        this.SetState(STATE.SPEAK);
      }
      return BEAR_ANIM.SPEAK;
    }
    switch (this.state) {
      case STATE.TYPING:
        return BEAR_ANIM.EAR;
      case STATE.BLINKING:
        return BEAR_ANIM.BLINK;
      // @ts-ignore
      case STATE.SPEAK:
        this.SetState(STATE.NONE);
        this.resetBlinkTimer();
      // 소리 재생이 끝남.
      // 이어서 계속
      case STATE.NONE:
        return BEAR_ANIM.NORMAL;
    }
  }

  /**
   * 타이핑이 시작되고 끝나는 정보를 설정한다.
   * @param set
   */
  public set typing(set: boolean) {
    this.SetState(set ? STATE.TYPING : STATE.NONE);

    this.resetBlinkTimer();
  }

  private resetBlinkTimer(): void {
    if (this.timer$) {
      this.timer$.unsubscribe();
      this.timer$ = null;
    }

    const process = () => {
      this.timer$ = timer(BEAR_BLINK_DELAY).subscribe(() => {
        // console.warn('time out');
        this.SetState(STATE.BLINKING);

        this.timer$ = timer(BEAR_BLINK_DURATION).pipe(
          finalize(() => this.timer$ = null),
        ).subscribe(() => {
          this.SetState(STATE.NONE);
          process();
        });
      });
    };

    process();
  }

  private SetState(state: STATE): void {
    // console.warn('BearService::SetState() state: ', getEnumNameByValue(STATE, state));
    this.state = state;
  }

  public reset(): void {
    // 모든 상태와 타이머를 리셋
    this.typing = false;
    if (this.timer$) {
      this.timer$.unsubscribe();
      this.timer$ = null;
    }
    this.resetBlinkTimer();
  }
}
